export default {"src":"/_next/static/media/tutor_revenue.291d663f.svg","height":715,"width":974};